export default "__VITE_ASSET__BAwBx9Ge__"